import { HomePage } from 'pages/HomePage';
import { SignInPage } from 'pages/SignInPage';
import { RecurringAuthPage } from 'pages/RecurringAuthPage';
import { useRoutes } from 'react-router';
import { LoginPage } from 'pages/LoginPage';
import { MonthlyFeePage } from 'pages/MonthlyFeePage';
import { LinkPage } from 'pages/LinkPage';
import { SwedBankIntegrationPage } from 'pages/SwedBankIntegrationPage';
import { VATReportDownloadPage } from 'pages/VATReportDownloadPage';
import { VATReportPage } from 'pages/VATReportPage';
import { DashboardPage } from 'pages/DashboardPage';
import { HMRCPage } from 'pages/HMRCPage';
import { ErrorItemPage } from 'pages/ErrorItemPage';
import { ErrorsTablePage } from 'pages/ErrorsTablePage';
import { ShipmentsPage } from 'pages/ShipmentsPage';
import { NotFoundPage } from 'pages/404';
import { VatReimbursementManagementPage } from 'pages/VatReimbursementManagementPage';
import { GpsrPage } from 'pages/GpsrPage';
import { GpsrProductTypePage } from 'pages/GpsrProductTypePage';
import { SalesProcessingPage } from 'pages/SalesProcessingPage';
import { SalesReportsPage } from 'pages/SalesReportsPage';
import { ReferenceTablesPage } from 'pages/ReferenceTablesPage';
import { EMManagementPage } from 'pages/EMManagementPage';
import { EMManagementCreatePage } from 'pages/EMManagementCreatePage';
import { EMManagementIdPage } from 'pages/EMManagementIdPage';
import { ReferralsPage } from 'pages/ReferralsPage';
import { ReferralsPartnersPage } from 'pages/ReferralsPartnersPage';
import { ReferralsReportsPage } from 'pages/ReferralsReportsPage';
import { GpsrInvoicesPage } from 'pages/GpsrInvoicesPage';
import { FiscalReportsPage } from 'pages/FiscalReportsPage';
import { ChangeHistoryPage } from 'pages/ChangeHistoryPage';
import { CommunicationHistoryPage } from 'pages/CommunicationHistoryPage';
import { CommunicationHistoryDetailPage } from 'pages/CommunicationHistoryDetailPage';
import { HsCodesRetrievingPage } from 'pages/HsCodesRetrievingPage';
import { EUDRPage } from 'pages/EUDRPage';
import { EUDRUserPage } from 'pages/EUDRUserPage';
import { UserManagementPage } from 'pages/UserManagementPage';
import { InvoiceManagementPage } from 'pages/InvoiceManagementPage';
import { InvoiceManagementDetailPage } from 'pages/InvoiceManagementDetailPage';
import { CreditNotesPage } from 'pages/CreditNotesPage';
import { CreditNoteDetailsPage } from 'pages/CreditNoteDetailsPage';
import { InvoiceArchiveDownloadPage } from 'pages/InvoiceArchiveDownloadPage';
import { OrderManagementPage } from 'pages/OrderManagementPage';
import { OrderManagementDetailPage } from 'pages/OrderManagementDetailPage';
import { EuDdpOrdersPage } from 'pages/EuDdpOrdersPage';
import { EuDdpOrderDetailPage } from 'pages/EuDdpOrderDetailPage';
import { EuDdpPrintLabelsPage } from 'pages/EuDdpPrintLabelsPage';
import { UserChangeHistoryPage } from 'pages/UserChangeHistoryPage';
import { TaskTrackerPage } from 'pages/TaskTrackerPage';
import { EmVatCorrectionsPage } from 'pages/EmVatCorrectionsPage';
import { ShopifyStoreDetailsPage } from 'pages/ShopifyStoreDetailsPage';
import { MassPostSaleJobsPage } from 'pages/MassPostSaleJobsPage';
import { MassPostSaleJobOrdersPage } from 'pages/MassPostSaleJobOrdersPage';
import { PrpPage } from 'pages/PrpPage';
import { PpwrPage } from 'pages/PpwrPage';
import { PpwrRegistrationFormsPage } from 'pages/PpwrRegistrationFormsPage';
import { PpwrSettingsPage } from 'pages/PpwrSettingsPage';
import { PaymentGatewayPage } from 'pages/PaymentGatewayPage';
import { ReportingCenterPage } from 'pages/ReportingCenterPage';
import { PATHS } from './constants';

export const NavigateList = () => {
	const routes = useRoutes([
		{
			path: PATHS.AUTH_CODE_PAGE,
			element: <RecurringAuthPage />,
		},
		{
			path: PATHS.HOME_PAGE,
			element: <HomePage />,
		},
		{
			path: PATHS.SIGN_IN_PAGE,
			element: <SignInPage />,
		},
		{
			path: PATHS.LOGIN_PAGE,
			element: <LoginPage />,
		},
		{
			path: PATHS.MONTHLY_FEE_PAGE,
			element: <MonthlyFeePage />,
		},
		{
			path: PATHS.RESOURCES,
			element: <LinkPage />,
		},
		{
			path: PATHS.SWED_BANK_INTEGRATION_PAGE,
			element: <SwedBankIntegrationPage />,
		},
		{
			path: PATHS.VAT_REPORT_PAGE,
			element: <VATReportPage />,
		},
		{
			path: PATHS.VAT_REPORT_DOWNLOAD_PAGE,
			element: <VATReportDownloadPage />,
		},
		{
			path: PATHS.DASHBOARD_PAGE,
			element: <DashboardPage />,
		},
		{
			path: PATHS.HMRC_PAGE,
			element: <HMRCPage />,
		},
		{
			path: PATHS.HMRC_DETILES,
			element: <HMRCPage />,
		},
		// {
		// 	path: PATHS.HMRC_LEVEL2,
		// 	element: <HMRCPage />,
		// },
		// {
		// 	path: PATHS.HMRC_LEVEL3,
		// 	element: <HMRCPage />,
		// },
		{
			path: PATHS.ERROR_CORRECTIONS_PAGE,
			element: <ErrorsTablePage />,
		},
		{
			path: PATHS.ERROR_CORRECTION_PAGE,
			element: <ErrorItemPage />,
		},
		{
			path: PATHS.SWISS_POST_PAGE,
			element: <ShipmentsPage />,
		},
		{
			path: PATHS.VAT_REIMBURSEMENT_MANAGEMENT_PAGE,
			element: <VatReimbursementManagementPage />,
		},
		{
			path: PATHS.GPSR_PAGE,
			element: <GpsrPage />,
		},
		{
			path: PATHS.EUDR_PAGE,
			element: <EUDRPage />,
		},
		{
			path: PATHS.EUDR_USER_PAGE,
			element: <EUDRUserPage />,
		},
		{
			path: PATHS.GPSR_PRODUCT_TYPE_PAGE,
			element: <GpsrProductTypePage />,
		},
		{
			path: PATHS.GPSR_REGULATIONS_PAGE,
			element: <GpsrProductTypePage />,
		},
		{
			path: PATHS.GPSR_INVOICES_PAGE,
			element: <GpsrInvoicesPage />,
		},
		{
			path: PATHS.SALES_PROCESSING_PAGE,
			element: <SalesProcessingPage />,
		},
		{
			path: PATHS.SALES_REPORTS_PAGE,
			element: <SalesReportsPage />,
		},
		{
			path: PATHS.REFERENCE_TABLES_PAGE,
			element: <ReferenceTablesPage />,
		},
		{
			path: PATHS.REFERENCE_TABLES_TAB_PAGE,
			element: <ReferenceTablesPage />,
		},
		{
			path: PATHS.PAYMENT_GATEWAY_PAGE,
			element: <PaymentGatewayPage />,
		},
		{
			path: PATHS.PAYMENT_GATEWAY_TAB_PAGE,
			element: <PaymentGatewayPage />,
		},
		{
			path: PATHS.REPORTING_CENTER_PAGE,
			element: <ReportingCenterPage />,
		},
		{
			path: PATHS.EM_MANAGEMENT_PAGE,
			element: <EMManagementPage />,
		},
		{
			path: PATHS.EM_MANAGEMENT_CREATE_PAGE,
			element: <EMManagementCreatePage />,
		},
		{
			path: PATHS.EM_VAT_CORRECTIONS_PAGE,
			element: <EmVatCorrectionsPage />,
		},
		{
			path: PATHS.EM_MANAGEMENT_ID_PAGE,
			element: <EMManagementIdPage />,
		},
		{
			path: PATHS.EM_MANAGEMENT_CHANGE_HISTORY_PAGE,
			element: <ChangeHistoryPage />,
		},
		{
			path: PATHS.EM_MANAGEMENT_COMMUNICATION_HISTORY_PAGE,
			element: <CommunicationHistoryPage />,
		},
		{
			path: PATHS.EM_MANAGEMENT_COMMUNICATION_HISTORY_DETAIL_PAGE,
			element: <CommunicationHistoryDetailPage />,
		},
		{
			path: PATHS.EM_MANAGEMENT_SHOPIFY_STORE_DETAILS_PAGE,
			element: <ShopifyStoreDetailsPage />,
		},
		{
			path: PATHS.PRP_PAGE,
			element: <PrpPage />,
		},
		{
			path: PATHS.PPWR_PAGE,
			element: <PpwrPage />,
		},
		{
			path: PATHS.PPWR_REGISTRATION_FORMS_PAGE,
			element: <PpwrRegistrationFormsPage />,
		},
		{
			path: PATHS.PPWR_SETTINGS_PAGE,
			element: <PpwrSettingsPage />,
		},
		{
			path: PATHS.REFERRALS_PAGE,
			element: <ReferralsPage />,
		},
		{
			path: PATHS.REFERRALS_PARTNERS_PAGE,
			element: <ReferralsPartnersPage />,
		},
		{
			path: PATHS.REFERRALS_REPORTS_PAGE,
			element: <ReferralsReportsPage />,
		},
		{
			path: PATHS.FISCAL_REPORTS_PAGE,
			element: <FiscalReportsPage />,
		},
		{
			path: PATHS.HS_CODES_RETRIEVING_PAGE,
			element: <HsCodesRetrievingPage />,
		},
		{
			path: PATHS.TASK_TRACKER_PAGE,
			element: <TaskTrackerPage />,
		},
		{
			path: PATHS.USER_MANAGEMENT_PAGE,
			element: <UserManagementPage />,
		},
		{
			path: PATHS.USER_MANAGEMENT_CHANGE_HISTORY_PAGE,
			element: <UserChangeHistoryPage />,
		},
		{
			path: PATHS.INVOICE_MANAGEMENT_PAGE,
			element: <InvoiceManagementPage />,
		},
		{
			path: PATHS.INVOICE_MANAGEMENT_CREDIT_NOTES_PAGE,
			element: <CreditNotesPage />,
		},
		{
			path: PATHS.INVOICE_MANAGEMENT_CREDIT_NOTE_DETAILS_PAGE,
			element: <CreditNoteDetailsPage />,
		},
		{
			path: PATHS.INVOICE_MANAGEMENT_ID_PAGE,
			element: <InvoiceManagementDetailPage />,
		},
		{
			path: PATHS.ORDER_MANAGEMENT_PAGE,
			element: <OrderManagementPage />,
		},
		{
			path: PATHS.ORDER_MANAGEMENT_DETAIL_PAGE,
			element: <OrderManagementDetailPage />,
		},
		{
			path: PATHS.EU_DDP_ORDERS_PAGE,
			element: <EuDdpOrdersPage />,
		},
		{
			path: PATHS.EU_DDP_PRINT_LABELS_PAGE,
			element: <EuDdpPrintLabelsPage />,
		},
		{
			path: PATHS.EU_DDP_ORDER_DETAIL_PAGE,
			element: <EuDdpOrderDetailPage />,
		},
		{
			path: PATHS.MASS_POST_SALE_JOBS_PAGE,
			element: <MassPostSaleJobsPage />,
		},
		{
			path: PATHS.MASS_POST_SALE_JOB_ORDERS_PAGE,
			element: <MassPostSaleJobOrdersPage />,
		},
		{
			path: PATHS.DOWNLOAD_INVOICE_ARCHIVE_PAGE,
			element: <InvoiceArchiveDownloadPage />,
		},
		{
			path: '*',
			element: <NotFoundPage />,
		},
	]);
	return routes;
};
